import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation, Link } from 'react-router-dom';

import { formatNull } from '../../Utils/GlobalUtils';
import { useTimeModal } from '../TimeModal/TimeModalContext';

import LoadingLines from '../LoadingLines';
import WarningPanel from '../WarningPanel';

import styles from '../../styles/MiniTables.module.css';

import ButtonWithConfirmation from '../ButtonWithConfirmation';
import { ReactComponent as MinusCircleIcon } from '../../icons/minus-circle.svg';
import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/pen.svg';

export default function ApplicantCases({ applicantId, case_ids, isShowNullTable=true, reload, onSuccess, access=false, isShowButtons=false }) {
    const navigate = useNavigate();
    const location = useLocation();

    const { openTimeModal } = useTimeModal();

    const [entries, setEntries] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [warning, setWarning] = React.useState(true);

    React.useEffect(() => {
        const token = localStorage.getItem('token');

        if (!case_ids || case_ids.length === 0) {
        if (isShowNullTable) setWarning('Заявитель не прикреплен к карточкам');
        setEntries([]);
        setLoading(false);
        return;
        }
        
        axios.get(`/api/get-applicant-cases`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                case_ids: case_ids.join(','),
            }
        })
        .then((response) => {
        if (response.data.length === 0) {
            if (isShowNullTable) {
                setWarning('Заявитель не прикреплен к карточкам');
            } else {
                setWarning('');
            }
            setEntries([]);
        } else {
            setWarning(``);
            setEntries(response.data);
        }
        })
        .catch((error) => {
            console.log(error)
            setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            setEntries([]);
        })
        .finally(() => {
            setLoading(false);
        })
    }, [reload, case_ids.join(',')]);

    const deleteApplicantCase = (caseId, applicantId) => {
        const token = localStorage.getItem('token');

        axios.delete(`/api/delete-case-applicant?applicant_id=${applicantId}&case_id=${caseId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            openTimeModal('Заявитель успешно откреплен', 'success');
            onSuccess();
        })
        .catch(() => {
            openTimeModal('Ошибка при открепления заявителя от дела', 'error');
        })
        .finally(() => {
            onSuccess();
        });
    };

    return (
        <>
        {loading ? <LoadingLines />
        : warning ? <WarningPanel text={warning} />
        : entries.length > 0 && 
        <div className={styles.table}>
            {entries.map((entry) => (
                <div 
                    className={styles.line}
                    key={entry.id} 
                    style={{ gridTemplateColumns: '50fr 49fr 1fr 1fr' }}
                >
                    <div>
                        {access ? 
                            <Link
                                className='aWithLink'
                                to={`/case/${entry.id}`}
                            >
                                {formatNull(entry.number)}
                            </Link>
                            :
                            <p>
                                {formatNull(entry.number)}
                            </p>
                        }
                    </div>
                    <div>
                        {formatNull(entry.court_name)}
                    </div>
                    {(access && isShowButtons) &&
                    <>
                    <div>
                        <IconContainer 
                            Icon={XIcon} 
                            label='Изменить данные'
                            onClick={() => {
                                navigate(`/change-case/${entry.id}`, { state: { from: location.pathname + location.search + location.hash }})
                            }} 
                            size = '16' 
                            color = 'black' 
                            className = '' 
                        />
                    </div>
                    <div>
                        <ButtonWithConfirmation 
                            entryFunc={() => {deleteApplicantCase(entry.id, applicantId)}} 
                            Icon={MinusCircleIcon} 
                            IconSize={16}
                            labelText='Открепить заявителя' 
                            buttonName='Открепить заявителя' 
                            color='black' 
                        />
                    </div>
                    </>}
                </div>
            ))}
        </div>}
        </>
    )
}
